<template>
  <div>
    <item-table v-show="activeKey===1" ref="list" :data-sources="dataSources" :owners="owners" :sale-classifications="saleClassifications" :storage-classifications="storageClassifications" :storage-environments="storageEnvironments" @add="add" @config="config" @edit="edit"/>
    <item-detail v-show="activeKey===2" ref="detail" :brands="brands" :data-sources="dataSources" :dosage-forms="dosageForms" :item-categories="itemCategories" :item-types="itemTypes" :legal-attributes="legalAttributes" :owners="owners" :sale-classifications="saleClassifications" :seasons="seasons" :storage-classifications="storageClassifications" :storage-environments="storageEnvironments" :storage-requests="storageRequests" :turnover-modes="turnoverModes" @back="back"/>
    <item-extra v-show="activeKey===3" ref="extra" :data-sources="dataSources" :limit-types="limitTypes" :shapes="shapes" @back="back"/>
  </div>
</template>
<script>
import { findAll, findEnum, findOne } from '@/api/Api'
import ItemTable from '@/views/basedata/item/ItemTable.vue'
import ItemDetail from '@/views/basedata/item/ItemDetail.vue'
import ItemExtra from '@/views/basedata/item/ItemExtra.vue'

export default {
  name: 'ItemBaseData',
  components: { ItemTable, ItemDetail, ItemExtra },
  data() {
    return {
      activeKey: 1,
      owners: [],
      itemTypes: [],
      itemCategories: [],
      legalAttributes: [],
      brands: [],
      seasons: [],
      dataSources: [],
      saleClassifications: [],
      storageClassifications: [],
      turnoverModes: [],
      storageEnvironments: [],
      storageRequests: [],
      dosageForms: [],
      shapes: [],
      limitTypes: []
    }
  },
  async created() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = res.result.map(item => {
          return { label: item.name, value: item.id }
        })
      }
    })
    await findOne('fieldFactory', { no: 'ITEM_TYPE' }).then(res => {
      if (res.success) {
        this.itemTypes = res.result.dictionaries.map(item => {
          return { label: item.name, value: item.id }
        })
      }
    })
    let args
    await findOne('parameterFactory', { name: '商品类别层级' }).then(res => {
      if (res.success) args = { no: res.result.value }
    })
    await findOne('fieldFactory', args).then(res => {
      if (res.success) {
        this.itemCategories = res.result.dictionaries.map(item => {
          return { label: item.name, value: item.id }
        })
      }
    })
    await findOne('fieldFactory', { no: 'LEGAL_ATTR' }).then(res => {
      if (res.success) {
        this.legalAttributes = res.result.dictionaries.map(item => {
          return { label: item.name, value: item.id }
        })
      }
    })
    await findOne('fieldFactory', { no: 'BRAND' }).then(res => {
      if (res.success) {
        this.brands = res.result.dictionaries.map(item => {
          return { label: item.name, value: item.id }
        })
      }
    })
    await findOne('fieldFactory', { no: 'SEASON' }).then(res => {
      if (res.success) {
        this.seasons = res.result.dictionaries.map(item => {
          return { label: item.name, value: item.id }
        })
      }
    })
    findEnum('DataSource').then(res => {
      if (res.success) {
        this.dataSources = res.result.map(item => {
          return { label: item.name, value: item.ordinal }
        })
      }
    })
    findEnum('SaleClassification').then(res => {
      if (res.success) {
        this.saleClassifications = res.result.map(item => {
          return { label: item.name, value: item.ordinal }
        })
      }
    })
    findEnum('StorageClassification').then(res => {
      if (res.success) {
        this.storageClassifications = res.result.map(item => {
          return { label: item.name, value: item.ordinal }
        })
      }
    })
    findEnum('TurnoverMode').then(res => {
      if (res.success) {
        this.turnoverModes = res.result.map(item => {
          return { label: item.name, value: item.ordinal }
        })
      }
    })
    findEnum('StorageEnvironment').then(res => {
      if (res.success) {
        this.storageEnvironments = res.result.map(item => {
          return { label: item.name, value: item.ordinal }
        })
      }
    })
    await findOne('fieldFactory', { no: 'STORAGE_REQUEST' }).then(res => {
      if (res.success) {
        this.storageRequests = res.result.dictionaries.map(item => {
          return { label: item.name, value: item.id }
        })
      }
    })
    await findOne('fieldFactory', { no: 'DOSAGE_FORM' }).then(res => {
      if (res.success) {
        this.dosageForms = res.result.dictionaries.map(item => {
          return { label: item.name, value: item.id }
        })
      }
    })
    findEnum('Shape').then(res => {
      if (res.success) {
        this.shapes = res.result.map(item => {
          return { label: item.name, value: item.ordinal }
        })
      }
    })
    findEnum('LocationLimitType').then(res => {
      if (res.success) {
        this.limitTypes = res.result.map(item => {
          return { label: item.name, value: item.ordinal }
        })
      }
    })
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.refresh()
    },
    add() {
      this.activeKey = 2
      this.$refs.detail.add()
    },
    edit(id, copy) {
      this.activeKey = 2
      this.$refs.detail.refresh(id, copy)
    },
    config(item) {
      this.activeKey = 3
      this.$refs.extra.refresh(item)
    }
  }
}
</script>